// extracted by mini-css-extract-plugin
export default {"title":"bba-z","warning":"cba-z","sizeOptionsLegendText":"dba-z"};